import React from 'react'

/**
 * 削除エラーメッセージを表示するコンポーネント
 *
 * @param {{ errorMessage: string | null }} props
 */
export const ShowDeleteError = React.memo(({ errorMessage }) => {
  if (!errorMessage) {
    return null
  }

  return (
    <div className="mb-4">
      <span className="red--text">{errorMessage}</span>
    </div>
  )
})
